import { render } from "./MainParent.vue?vue&type=template&id=cde942ac"
import script from "./MainParent.vue?vue&type=script&lang=js"
export * from "./MainParent.vue?vue&type=script&lang=js"

import "./MainParent.vue?vue&type=style&index=0&id=cde942ac&lang=css"

import exportComponent from "../../../../../../name-pronunciation/orator-pro-frontend/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__